
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summer-camp/explore",
      function () {
        return require("private-next-pages/summer-camp/explore.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summer-camp/explore"])
      });
    }
  